<div>
  @if ($initAuthInProgress()) {
    <app-view-loader />
  }
  <router-outlet />
</div>
